export const environment = {
    production: false,
    deploymentEnv: 'azl',
    oldVersionUrl: 'https://practice.courts.gov.ng/home.jsp'
    
};
